/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
import { Component, Fragment } from 'react'
import Autosuggest from 'react-autosuggest'
import { injectIntl, defineMessages, intlShape } from 'react-intl'
import filter from 'lodash/filter'
import { getOffset, generateQueryForTrip } from '../../utils'
import each from 'lodash/each'
import clone from 'lodash/clone'
import sortBy from 'lodash/sortBy'
import findLastIndex from 'lodash/findLastIndex'
import findIndex from 'lodash/findIndex'
import API from '../../api'
import { createUrl } from '../../localized-urls'
import messages from '../../messages'

import './autosuggest.sass'

const msg = defineMessages({
  tripsIn: {
    id: 'trips_in',
    defaultMessage: 'Group trips {location}',
  },
  operatorsIn: {
    id: 'operators_in',
    defaultMessage: 'Dive operators {location}',
  },
  liveaboardsIn: {
    id: 'liveaboards_in',
    defaultMessage: 'Liveaboards {location}',
  },
  diveResortIn: {
    id: 'dr_in',
    defaultMessage: 'Dive resorts {location}',
  },
  diveCentersIn: {
    id: 'dc_in',
    defaultMessage: 'Dive centers {location}',
  },
  diveSitesIn: {
    id: 'ds_in',
    defaultMessage: 'Dive sites {location}',
  },
  groupTripsIn: {
    id: 'groups_in',
    defaultMessage: 'Group trips {location}',
  },
  scubaGuidesIn: {
    id: 'scuba_guides_in',
    defaultMessage: '{ location } scuba guide',
  },
})

const renderIcon = suggestion => {
  let template
  if(suggestion.modelType === 'Shop' && suggestion.firstRow) {
    template = (<i className={`font-icons 
            ${suggestion.kind === 10 ? 'liveaboard-icon' : ''} 
            ${suggestion.kind === 20 ? 'dive-resort-icon' : ''} 
            ${suggestion.kind === 0 ? 'dive-center-icon' : ''}`
    } />)
  } else if(suggestion.modelType === 'Fleet') {
    template = (<i className='font-icons liveaboard-icon' />)
  } else if(suggestion.modelType === 'Travel guides' && suggestion.firstRow) {
    template = (<i className='font-icons icon-information' />)
  } else if((suggestion.modelType === 'Location' || suggestion.modelType === 'Geo-Location') && suggestion.firstRow) {
    template = (<i className='font-icons find-icon' />)
  }
  return template
}

export const getHighlightedText = function(text, higlight) {
  if(!text) {
    return ''
  }
  // Split on higlight term and include term into parts, ignore case
  let parts = text.split(new RegExp(`(${higlight})`, 'gi'))
  return <span> { parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === higlight.toLowerCase() ? { fontWeight: 'bold' } : {}}>
      { part }
    </span>)
  } </span>
}

const renderSuggestion = (suggestion, { query }) =>
  (<div className={`typeahead-item ${suggestion.last ? 'last' : ''} ${suggestion.modelType === 'Travel guides' ? 'guide' : ''}`}>
    <div className='img-wrap'>
      {renderIcon(suggestion)}
    </div>
    <div className='typeahead-title'>
      <span className='location-title'>{getHighlightedText(suggestion.title, query)}</span>
      <span className='location-text'>{getHighlightedText(suggestion.name, query) || ' '}</span>
    </div>
  </div>
  )

class Typeahead extends Component {
  constructor(props) {
    super(props)

    if(props.popupId) {
      this.popup = document.getElementById(props.popupId)
    }

    this.inputRef = React.createRef()
    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: props.inputValue || '',
      suggestions: [],
      popupVisible: false,
    }
  }

  componentDidMount() {
    const ref = this.inputRef.current.input
    this.inputOffset = getOffset(ref)
    if(this.popup && this.props.handlePopupItems) {
      const urls = this.popup.getElementsByTagName('a')
      const toggleButtons = this.popup.querySelectorAll('.option')
      const countriesList = this.popup.getElementsByClassName('country-list-wrapper')
      if(urls) {
        urls.forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault()
            const itemKind = +(item.getAttribute('kind'))
            this.onSuggestionSelected(e, {
              suggestion: {
                modelType: 'PopupLink',
                url: item.getAttribute('href'),
                kind: itemKind,
                title: item.text,
                itemTitle: item.text,
                searchKind: itemKind === 10 ? 'LA' : 'DR',
              },
            })
            this.hidePopup()
            this.setState({
              value: item.text,
            })
          })
        })
      }

      if(toggleButtons) {
        toggleButtons.forEach(button => {
          button.addEventListener('click', () => {
            if(!button.classList.contains('active')) {
              toggleButtons.forEach(button => {
                button.classList.remove('active')
              })
              button.classList.add('active')
              countriesList.forEach((item) => {
                item.classList.toggle('active')
              })
              if(this.props.onToggleButtonClick) {
                this.props.onToggleButtonClick(button.getAttribute('kind'))
              }
            }
          })
        })
      }

      document.addEventListener('click', (e) => {
        if(this.state.popupVisible) {
          let element = e.target
          let parents = []
          let clickedOutside = true
          while(element) {
            parents.unshift(element)
            element = element.parentNode
          }
          parents.forEach(elem => {
            if(elem.id === this.props.popupId || elem === ref) {
              clickedOutside = false
            }
          })
          if(clickedOutside) {
            this.hidePopup()
          }
        }
      })
    }
    // if(this.popup && this.props.isWidget) {
    //   this.popup.querySelectorAll('a').forEach(link => {
    //     const url = without(link.getAttribute('href').split('/'), '')

    //     if(this.props.kind === 20 && url) {
    //       link.setAttribute('href', `${APP_LANGUAGE === 'en' ? '' : '/' + APP_LANGUAGE}/widget/s/dr/${url[url.length - 1]}/`)
    //     } else {
    //       link.setAttribute('href', `${APP_LANGUAGE === 'en' ? '' : '/' + APP_LANGUAGE}/widget/s/${url[url.length - 1]}/`)
    //     }
    //   })
    // }
  }

  showPopup() {
    if(this.popup) {
      this.inputOffset = getOffset(this.inputRef.current.input)
      this.popup.style.opacity = 1

      if(this.inputOffset.left + this.popup.offsetWidth > window.innerWidth - 20) {
        this.popup.style.left = `${(window.innerWidth - this.popup.offsetWidth) / 2}px`
      } else {
        this.popup.style.left = `${this.inputOffset.left}px`
      }
      this.popup.style.top = `${this.inputOffset.top + 45}px`
      this.setState({
        popupVisible: true,
      })
    }
  }

  hidePopup() {
    if(this.popup) {
      this.popup.style.opacity = 0
      this.setState({
        popupVisible: false,
      })
      setTimeout(() => {
        this.popup.style.left = '-9999px'
      }, 300)
    }
  }

  onSuggestionSelected = (event, { suggestion }) => {
    let searchUrl = ''
    let type
    let newTabRequired = false
    let location = suggestion.area

    const searchLaLink = this.props.isWidget ? 'widget_search_la' : 'search_la'
    const searchDrLink = this.props.isWidget ? 'widget_search_dr' : 'search_dr'

    if(suggestion.modelType === 'PopupLink') {
      searchUrl = suggestion.url
    } else if(suggestion.modelType === 'Shop') {
      if(suggestion.kind === 0) {
        // url += '/dive-center'
      } else if(suggestion.kind === 10) {
        // url += '/liveaboard';
        type = 'la_page'
        location = suggestion.country
      } else if(suggestion.kind === 20) {
        type = 'dr_page'
        // url += '/dive-resort';
        location = suggestion.country
      } else if(suggestion.kind === 30) {
        // url += '/dive-sites'
      }

      newTabRequired = true

      searchUrl = createUrl(type, {
        location: location,
        slug: suggestion.slug,
      })
    } else if(suggestion.modelType === 'Travel guides') {
      searchUrl = createUrl('destination', { location: suggestion.slug })
      newTabRequired = true
    } else if(suggestion.modelType === 'Fleet') {
      searchUrl = createUrl('fleets', { slug: suggestion.slug })
      newTabRequired = true
    } else {
      if(suggestion.searchKind) {
        if(suggestion.searchKind === 'LA') {
          searchUrl = createUrl(searchLaLink, { slug: suggestion.slug })
        } else if(suggestion.searchKind === 'DR') {
          searchUrl = createUrl(searchDrLink, { slug: suggestion.slug })
        } else if(suggestion.searchKind === 'DC') {
          searchUrl = createUrl({ type: 'dive-centers', slug: suggestion.slug })
        } else if(suggestion.searchKind === 'DS') {
          searchUrl = createUrl({ type: 'dive-sites', slug: suggestion.slug })
        } else if(suggestion.searchKind === 'Group') {
          searchUrl = createUrl('group_trips', { slug: suggestion.slug })
        }
      } else {
        if(suggestion.modelType === 'Geo-Location') {
          searchUrl = createUrl(searchDrLink, { slug: suggestion.slug })
        } else {
          if(this.props.kind) {
            if(this.props.kind === 10) {
              searchUrl = createUrl(suggestion.hasLiveaboards ? searchLaLink : searchDrLink, { slug: suggestion.slug })
            } else {
              searchUrl = createUrl(suggestion.hasDiveResorts ? searchDrLink : searchLaLink, { slug: suggestion.slug })
            }
          } else {
            searchUrl = createUrl(suggestion.hasLiveaboards ? searchLaLink : searchDrLink, { slug: suggestion.slug })
          }
        }
      }
    }

    if(this.props.selectCallback) {
      this.props.selectCallback({
        url: searchUrl,
        item: suggestion,
      })
    } else {
      if(this.props.isWidget && newTabRequired) {
        window.open(searchUrl + generateQueryForTrip(false, true), '_blank')
      } else {
        window.location.href = searchUrl
      }
    }

    // return suggestion.title
  }

  getSuggestionValue = suggestion => {
    return suggestion.title
  }

  onChange = (event, { newValue }) => {
    if(this.popup) {
      if(newValue.length < 3) {
        this.showPopup()
      } else {
        this.hidePopup()
      }
    }

    this.setState({
      value: newValue,
    })
  }

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = ({ value }) => {
    const { intl } = this.props

    if(value.length < 3) {
      this.setState({
        suggestions: [],
      })

      return false
    }

    let params = { q: value }

    if(this.props.type === 'group') {
      /// Ха-ха, ебучий костыль
      params.kind = 999
    }

    // if(this.props.kind) {
    //   params.kind = this.props.kind
    // }

    API('search/homepage/').get(params).then((data) => {
      let shops = []
      let liveaboards = []
      let locations = []
      let travelGuides = []
      let fleets = []
      let locationsCount = filter(data, function(item) {
        return item.modelType === 'Geo-Location' || item.modelType === 'Location'
      })

      each(data, function(item, key) {
        let elem = clone(item)
        item.order = key
        item.itemTitle = item.title
        if(item.modelType === 'Shop' && item.kind !== 10) {
          shops.push(item)
        } else if(item.modelType === 'Shop' && item.kind === 10) {
          liveaboards.push(item)
        } else if(item.modelType === 'Geo-Location' || item.modelType === 'Location') {
          if(!locations.length) {
            item.firstRow = true
          }

          if(locationsCount.length > 1) {
            item.title = intl.formatMessage(msg.operatorsIn, { location: item.inTitle }),
            locations.push(item)
          } else {
            if(item.hasLiveaboards) {
              item.firstRow = !locations.length
              item.title = intl.formatMessage(msg.liveaboardsIn, { location: item.inTitle }),
              item.searchKind = 'LA'
              locations.push(clone(item))
            }

            if(item.hasDiveResorts) {
              item.firstRow = !locations.length
              item.title = intl.formatMessage(msg.diveResortIn, { location: item.inTitle }),
              item.searchKind = 'DR'
              locations.push(clone(item))
            }

            if(item.hasDiveCenters) {
              item.firstRow = !locations.length
              item.title = intl.formatMessage(msg.diveCentersIn, { location: item.inTitle }),
              item.searchKind = 'DC'
              locations.push(clone(item))
            }

            if(item.hasDiveSites) {
              item.firstRow = !locations.length
              item.title = intl.formatMessage(msg.diveSitesIn, { location: item.inTitle }),
              item.searchKind = 'DS'
              locations.push(clone(item))
            }

            if(item.hasGroupTrips) {
              item.firstRow = !locations.length
              item.title = intl.formatMessage(msg.groupTripsIn, { location: item.inTitle }),
              item.searchKind = 'Group'
              locations.push(clone(item))
            }
          }

          if(item.modelType === 'Location' && item.hasScubaguide) {
            let scubaGuide = clone(item)

            scubaGuide.modelType = 'Travel guides'
            scubaGuide.title = intl.formatMessage(msg.scubaGuidesIn, { location: elem.title })
            travelGuides.push(scubaGuide)
          }
        } else if(item.modelType === 'Fleet' && !fleets.length) {
          item.kind = 10
          item.name = 'Fleet'

          fleets.push(item)
        }
      })

      shops = sortBy(shops, 'order', 'desc')

      let shopsLength = shops.length
      let locationsLength = locations.length
      let lastDiveResortIndex; let lastDiveCenterIndex
      let firstDiveResortIndex; let firstDiveCenterIndex
      let travelGuidesLength = travelGuides.length

      if(shopsLength) {
        lastDiveResortIndex = findLastIndex(shops, {
          kind: 20,
        })
        lastDiveCenterIndex = findLastIndex(shops, {
          kind: 0,
        })

        // find first index
        firstDiveResortIndex = findIndex(shops, {
          kind: 20,
        })
        firstDiveCenterIndex = findIndex(shops, {
          kind: 0,
        })
        if(shops[lastDiveResortIndex]) {
          shops[lastDiveResortIndex].last = true
        }

        if(shops[lastDiveCenterIndex]) {
          shops[lastDiveCenterIndex].last = true
        }

        if(shops[firstDiveResortIndex]) {
          shops[firstDiveResortIndex].firstRow = true
        }
        if(shops[firstDiveCenterIndex]) {
          shops[firstDiveCenterIndex].firstRow = true
        }
      }

      if(liveaboards.length) {
        liveaboards[0].firstRow = true
        liveaboards = liveaboards.concat(fleets)

        liveaboards[liveaboards.length - 1].last = true
      } else {
        liveaboards = liveaboards.concat(fleets)
      }

      if(locationsLength) {
        locations[0].firstRow = true
        if(locationsCount === 1) {
          locations[locationsLength - 1].last = true
        } else {
          locations[locationsLength - 1].last = true
        }

        if(travelGuidesLength) {
          travelGuides[0].firstRow = true
          travelGuides[travelGuidesLength - 1].last = true
        }
      }

      if(value.kind === 'scubaguide') {
        return this.setState({
          suggestions: travelGuides,
        })
      }

      if(this.props.kind) {
        this.setState({
          suggestions: locations.concat(liveaboards).concat(shops),
        })
      } else {
        this.setState({
          suggestions: locations.concat(travelGuides).concat(liveaboards).concat(shops),
        })
      }
    })
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  render() {
    const { value, suggestions } = this.state
    const { placeholder, intl } = this.props

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: placeholder || intl.formatMessage(messages.search),
      value,
      autoComplete: 'off',
      onChange: this.onChange,
      onBlur: () => {
        if(!this.props.handlePopupItems) {
          this.hidePopup()
        }
      },
      onFocus: (e) => {
        try {
          e.currentTarget.setSelectionRange(0, value.length)
        } catch (err) {
          // Non IOs option if not supported, e.g. Chrome
          e.currentTarget.select()
        }

        if(this.popup) {
          if(value.length < 3) {
            this.showPopup()
          }
        }
      },
    }

    // Finally, render it!
    return (
      <Fragment>
        { this.props.withIcon ? (<i className='font-icons field-icon location-icon' />) : '' }
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          ref={this.inputRef}
        />
      </Fragment>
    )
  }
}

Typeahead.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(Typeahead)
